module.exports = __webpack_public_path__ + "img/fd87385.jpg";